import { escapeSql } from '@rdrive/helper-sql';
import { makeChartConfig } from '@rdrive/helper-chart-config';

// Issue distribution by controlling team, for @rdrive/plugin-chart-donut's BaseDonutChart
// (IA_ABSORPTION_PLAN Phase 4 step 12b; was components/charts/ControllerDonutChart.vue, whose
// query strings these are — the filter query now escapeSql()s its value, rule 6). Rendered `bare`
// in the Analysis page's Controller / Created By card. Returns raw rows: the "Others" bucket, the
// slice colours and the unknown-team label are the component's, as for project-overview's donut.
export function useControllerDonutChart({ chartName, filterContext, conn }) {
  // `rows` is the plain-row runner (the donut does not use the stacked bar's nested shape)
  const { rows: run, applyFilter, removeFilter } = makeChartConfig({ chartName, filterContext, conn });

  // Rows: { teamId, name (may be null), value }
  const getTeamDistribution = async () => {
    const rows = await run(`
    SELECT 
      i.IssueControlledByTeamId AS teamId,
      t."Name" AS name,
      COUNT(*) AS value
    FROM filteredIssues i
    LEFT JOIN teams t ON i.IssueControlledByTeamId = t.Id
    GROUP BY i.IssueControlledByTeamId, t."Name"
    ORDER BY value DESC
  `);

    return rows.map((row) => ({ ...row, value: Number(row.value) }));
  };

  // teamId === null clears this chart's filter registration
  const setTeamFilter = async (teamId) => {
    if (!teamId) {
      await removeFilter();
      return;
    }
    await applyFilter(`
      SELECT DISTINCT i.Id as id
      FROM issues i
      WHERE i.IssueControlledByTeamId = '${escapeSql(teamId)}'
    `);
  };

  return { getTeamDistribution, setTeamFilter };
}
